'use strict';

import * as timetableList from '../actions/timetableList';

var defaultState = {
    timetables: [],
    isNewTimetableOverlayOpen: false,
    isEditTimetableOverlayOpen: false,
    isDeleteTimetableOverlayOpen: false,
    formMode: 'add',
    timetableToEdit: null,
    timetableToDelete: null,
    defaultTimetable: {
        id: 0,
        name: '',
        periods: [{
            id: 0,
            time: '',
            description: ''
        }]
    }
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case timetableList.HIDE_EDIT_TIMETABLE_OVERLAY:

            return {
                ...state,
                isEditTimetableOverlayOpen: false
            };

        case timetableList.SHOW_EDIT_TIMETABLE_OVERLAY:

            return {
                ...state,
                formMode: 'edit',
                timetableToEdit: action.timetable,
                isEditTimetableOverlayOpen: true
            };

        case timetableList.SHOW_DELETE_TIMETABLE_OVERLAY:

            return {
                ...state,
                isDeleteTimetableOverlayOpen: true,
                timetableToDelete: action.timetable
            };

        case timetableList.HIDE_DELETE_TIMETABLE_OVERLAY:

            return {
                ...state,
                isDeleteTimetableOverlayOpen: false
            };

        case timetableList.TIMETABLES_REFRESHED:

            return {
                ...state,
                timetables: action.timetables
            };

        case timetableList.SHOW_NEW_TIMETABLE_OVERLAY:

            return {
                ...state,
                isNewTimetableOverlayOpen: true,
                formMode: 'add'
            };

        case timetableList.HIDE_NEW_TIMETABLE_OVERLAY:

            return {
                ...state,
                isNewTimetableOverlayOpen: false
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/timetableList.js